function namjestiToolbar() {
	$(".toolbarButtonUpisi").button({
		text : false,
		icons : {
			primary : "ui-icon-folder-collapsed"
		}
	});
	$(".toolbarButtonObrisi").button({
		text : false,
		icons : {
			primary : "ui-icon-trash"
		}
	});

}

function obradiToolbarUpisi(event, link, posao, podposao) {
	event.preventDefault();
	if (provjeriMijenjano(podposao)) {
		alert('Potrebno je zapisati podposao '+podposao+' u poslu '+posao);
	}
	else{
		alert('Podposao nije potrebno zapisivati - nije bilo izmjena!');
	}
}
function obradiToolbarBrisi(event, link, posao, podposao) {
	event.preventDefault();
	if (confirm("Da li ste sigurni da želite obrisati podposao broj "
			+ podposao + " u poslu broj " + posao + "?")) {
		$.ajax({
			url : link + "/" + posao + "/" + podposao,
			dataType : "json",
			success : function(data) {
				if (data) {
					$('#PodPosao' + podposao).remove();
				} else {
					alert('Brisanje nije uspjelo');
				}
			}
		});
	}
}

function dohvatiUgovorPartner(idPartner, link) {
	if (idPartner != '') {
		$.ajax({
			url : link + '/' + idPartner,
			type : "GET"
		}).done(function(data, textStatus, jqXHR) {
			$("body").append('<div id="dialogDiv"></div>');
			$("#dialogDiv").html(data);
			$sirina = $(window).width() * 0.98;
			$("#dialogDiv").dialog({
				width : $sirina,
				height : 'auto',
				title : "Pregled ugovora za partnera",
				modal : true,
				resizable : true,
				close : function() {
					$("body").remove("#dialogDiv");
				},
				buttons : {
					'Zatvori' : function() {
						$(this).dialog('close');
						$("body").remove("#dialogDiv");
					}
				}
			});
		}).fail(function(jqXHR, textStatus, errorThrown) {
			alert("Dogodila se greška kod dohvata podataka o ugovorima!");
		});

	} else {
		alert("Za pregled ugovora partnera potrebno je zadati šifru partnera!");
	}
}

function dajNotifikaciju(link, obavijest) {
	var n = noty({
		text : '<b>Poruka od:</b> ' + obavijest[0] + '<br>'
				+ '<b>Vrijeme poruke:</b> ' + obavijest[1] + '<br>'
				+ '<b>Tekst poruke:</b> ' + obavijest[2] + '<br>',
		type : 'alert',
		dismissQueue : true,
		layout : 'bottomRight',
		theme : 'defaultTheme',
		buttons : [ {
			addClass : 'btn btn-primary',
			text : 'Pročitano',
			onClick : function($noty) {
				$noty.close();
				$
						.ajax({
							url : link + '/' + obavijest[3],
							type : "GET"
						})
						.done(
								function(data, textStatus, jqXHR) {
									if (data) {
										noty({
											dismissQueue : true,
											force : true,
											layout : 'bottomRight',
											theme : 'defaultTheme',
											text : 'Obavijest broj '
													+ obavijest[3]
													+ ' je označena da je pročitana!!',
											type : 'success',
											timeout : 3000
										});
									} else {
										noty({
											dismissQueue : true,
											force : true,
											layout : 'bottomRight',
											theme : 'defaultTheme',
											text : 'Obavijest broj '
													+ obavijest[3]
													+ ' NIJE označena da je pročitana!!',
											type : 'error',
											timeout : 3000
										});
									}
								})
						.fail(
								function(jqXHR, textStatus, errorThrown) {
									noty({
										dismissQueue : true,
										layout : 'bottomRight',
										theme : 'defaultTheme',
										text : 'Dogodila se greška kod obrade obavijesti broj '
												+ obavijest[3] + '!!',
										type : 'error',
										timeout : 3000
									});
								});
			}
		} ]

	});
}

function osvjeziPartnerCombobox(sIDOsobe, sIDSpajanja, sIDProg) {
	if (sIDOsobe != '') {
		$('#'+sIDOsobe).selectmenu(
				{ 
					transferClasses : true,
					icons: [
							{find: '.zelenaSlova', icon: 'ui-icon-check'},
						],
					change: function(e) 
					{
					}
				});
	}
	if (sIDSpajanja != '') {
		$('#'+sIDSpajanja).selectmenu(
				{ 
					transferClasses : true,
					icons: [
							{find: '.zelenaSlova', icon: 'ui-icon-check'},
						],
					change: function(e) 
					{
					}
				});
	}
	if (sIDProg != '') {
		$('#'+sIDProg).selectmenu(
				{ 
					transferClasses : true,
					icons: [
							{find: '.zelenaSlova', icon: 'ui-icon-check'},
						],
					change: function(e, object){
				    }
				});
	}
}
function pratiPromjene(sContainer) {
	var sDodatak = sContainer.match(/\d+/);
	if (!$('#hbMIJENJANO'+sDodatak).length) {
		var $hiddenInput = $('<input/>',{type:'hidden',id:'hbMIJENJANO'+sDodatak,value:'0'});
		$hiddenInput.appendTo('#'+sContainer);
	}
	if (!$('#hsPOLJEMIJENJANJE'+sDodatak).length) {
		var $hiddenInput = $('<input/>',{type:'hidden',id:'hsPOLJEMIJENJANJE'+sDodatak,value:'damac'});
		$hiddenInput.appendTo('#'+sContainer);
	}
	$("input,textarea,select","#"+sContainer).focus(function() {
		$('#hsPOLJEMIJENJANJE'+sDodatak).val($(this).val());
	});
	$("input,textarea,select","#"+sContainer).blur(function() {
		if($('#hsPOLJEMIJENJANJE'+sDodatak).val() != $(this).val()){
			$('#hbMIJENJANO'+sDodatak).val('1');
		}
	});
};
function provjeriMijenjano (iPodPosao){
	return (!$('#hbMIJENJANO'+iPodPosao).length) || ($('#hbMIJENJANO'+iPodPosao).val() == '1');
}
function dohvatiOpisePoslova(link,iPosao){
	   if (iPosao != '') {
			$.ajax({
				url : link + '/' + iPosao,
				type : "GET"
			}).done(function(data, textStatus, jqXHR) {
				$("body").append('<div id="dialogDiv"></div>');
				$("#dialogDiv").html(data);
				sirina = $(window).width() * 0.5;
				$("#dialogDiv").dialog({
					width : sirina,
					height : 'auto',
					title : "Pregled opisa za posao "+iPosao,
					modal : true,
					resizable : true,
					close : function() {
						$("body").remove("#dialogDiv");
					},
					buttons : {
						'Zatvori' : function() {
							$(this).dialog('close');
							$("body").remove("#dialogDiv");
						}
					}
				});
			}).fail(function(jqXHR, textStatus, errorThrown) {
				alert("Dogodila se greška kod dohvata opisa za posao "+iPosao+"!");
			});

		} else {
			alert("Za pregled opisa posla potrebno je zadati šifru posla!");
		}
	   
	   }
function dohvatiPosao(rowid){
		alert('Dohvaćanje posal (ispravak) - kao u ekiwu sada');
	   }
function ispravakPosao(link,idGrid) {
	var id = jQuery("#"+idGrid).jqGrid('getGridParam', 'selrow');
	if (id) {
		var ret = jQuery("#"+idGrid).jqGrid('getRowData', id);
		window.location.href =link+'/'+ret.POSAO;
	} else {
		alert("Za ispravak odaberite zahtjev (red) koji želite ispraviti!");
	}
}